import { EdgeLabelRenderer, getBezierPath } from 'reactflow';
import './DeletableEdge.css';

export default function DeletableEdge({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  data,
}) {
  const [edgePath, labelX, labelY] = getBezierPath({
    sourceX,
    sourceY,
    targetX,
    targetY,
    sourcePosition,
    targetPosition,
  });

  return (
    <>
      {/* Hit area: largo e transparente para facilitar clique/hover */}
      <path
        d={edgePath}
        fill="none"
        stroke="transparent"
        strokeWidth={20}
        style={{ cursor: 'pointer' }}
        className="react-flow__edge-interaction"
      />

      {/* Linha sólida */}
      <path
        id={id}
        className="react-flow__edge-path flow-edge-line"
        d={edgePath}
        fill="none"
        markerEnd="url(#flow-purple-arrow)"
      />

      <EdgeLabelRenderer>
        {/* Bolinha viajando — animada via offset-distance (composited na GPU),
            bem mais leve que animar stroke-dashoffset no SVG (repaint por frame) */}
        <div
          className="flow-edge-dot"
          style={{ offsetPath: `path("${edgePath}")` }}
        />
        <div
          className="nodrag nopan"
          style={{
            position: 'absolute',
            transform: `translate(-50%, -50%) translate(${labelX}px,${labelY}px)`,
            pointerEvents: 'all',
          }}
        >
          <button
            type="button"
            className="h-5 w-5 rounded-full border border-white/10 bg-black/70 text-[10px] text-gray-400 hover:bg-red-600 hover:text-white"
            onClick={() => data?.onDelete?.(id)}
            title="Excluir linha"
          >
            X
          </button>
        </div>
      </EdgeLabelRenderer>
    </>
  );
}
